import { useEffect, useState } from 'react';
import { Col, Layout, List, message, Row } from 'antd';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { deleteTaskType, getTaskTypes, postTaskType, updateTaskType } from '../../../store/slice/taskTypeSlice';
import AddButton from '../../Molecules/AddButton/AddButton';
import TaskModal from '../../Organisms/TaskModal/TaskModal';
import SimpleCardView from '../../Organisms/SimpleCardView/SimpleCardView';
import TaskType from '../../../models/TaskType';
import { ReactComponent as Plus } from '../../../res/svg/plus.svg';
import './TaskTypesTemplate.less';
import Navbar from '../../Organisms/Navbar/Navbar';
import { userSubMenu } from '../../../utils/functions';
import { useNavigate } from 'react-router-dom';
import SectionIndicator, { subsections } from '../../Molecules/SectionIndicator/SectionIndicator';

/**
 * @template TaskTypes.tsx
 * @description Template to list the task types.
 * @return { template }
 */
function TaskTypesTemplate() {
  const dispatch = useAppDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [task, setTask] = useState<any[]>([]);
  const [edit, showEdit] = useState(false);
  const [editTask, setEditTask] = useState<any>({});
  let taskArray = [...task];
  let navigate = useNavigate();

  const showTaskModal = (show: boolean) => {
    setIsModalVisible(show);
    showEdit(false);
  };
  const isHidden = (show: boolean, deleteTask: TaskType) => {
    taskArray = [...task];
    if (deleteTask.id !== undefined) {
      const index = task.findIndex((item) => {
        return item.id === deleteTask.id;
      });
      dispatch(deleteTaskType(deleteTask)).then((response: any) => {
        if (response.payload.status) {
          taskArray.splice(index, 1);
          setTask(taskArray);
          message.success('El tipo de tarea fue Eliminada con éxito.');
        } else {
          message.error('Error,Tipo de tarea ligada a una tarea o rol.');
        }
      });
    }
    setIsModalVisible(show);
  };
  const taskType = (taskItem: TaskType) => {
    if (edit) {
      const newTask = new TaskType(
        editTask.task.id,
        taskItem.tipotarea!,
        taskItem.color!,
        taskItem.activo!,
      );
      taskArray = [...task];
      const index = task.findIndex((taskValue) => {
        return taskValue.id === editTask.task.id;
      });
      dispatch(updateTaskType(newTask)).then((response: any) => {
        if (response.payload.status) {
          taskArray[index] = { ...newTask };
          setTask(taskArray);
          message.success('El tipo de tarea fue editada con éxito.');
        }
      });
    } else {
      taskItem.activo = true;
      dispatch(postTaskType(taskItem)).then((response: any) => {
        if (response.payload.status) {
          taskItem.id = response.payload.data.id;
          const addTaskItem = [...task, taskItem];
          setTask(addTaskItem);
          message.success('El tipo de tarea fue creado con éxito.');
        }
      });
    }
  };
  const editOnClick = (editValue: any) => {
    setEditTask(editValue);
    setIsModalVisible(true);
    showEdit(true);
  };
  useEffect(() => {
    dispatch(getTaskTypes()).then((value: any) => {
      if (value.payload.status) {
        setTask(value.payload.data);
      } else {
        setTask([]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  return (
    <Layout>
      <Navbar subsection={'admin'} currentScreen={'admin/tipos-tareas'} showItems={true} itemsCallback={itemsCallback} />
      <SectionIndicator subsection={subsections.tiposTarea} />
      <Layout className='tp-task-type__main'>
        <div className={'tp-task-type__add-button-container'}>
          <div>
            <AddButton
              icon={<Plus />}
              title='Crear tipo de tarea'
              showModal={showTaskModal}
            />
          </div>
        </div>
        <Row>
          <Col>
            <div className='tp-task-type__card'>
              <List
                grid={{
                  gutter: 24,
                }}
                dataSource={task}
                renderItem={(item) => (
                  <SimpleCardView
                    key={item.id}
                    task={item}
                    onClick={editOnClick}
                    isRol={false}
                  />
                )}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
          {/**se usa la variable isModalVisible como condicional ya que si bien por dentro 
              se reinician los campos, tambien se necesita hacerlo para que se reinicie el color */}
          {
            isModalVisible ?
            (
              <TaskModal
              isHidden={isHidden}
              taskType={taskType}
              taskUpdate={editTask}
              isEdit={edit}
              />
            ) : null
          }
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
}

export default TaskTypesTemplate;
